module.exports = __webpack_public_path__ + "static/media/myeverpatheticlife.096037c5.png";